<template>
  <work-order-tracker :work_order='wo'></work-order-tracker>
</template>

<script>
import WorkOrderTracker from '@/components/trackers/WorkOrderTracker.vue';

export default {
  name: 'wo-action-tracker',
  props: {
    wo: {
      required: true
    }
  },
  components: {
    'work-order-tracker': WorkOrderTracker
  }
}
</script>
